import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { modifyFilterStatementList } from "../../../page/FilterPage/FilterSlice.js";


import { RangeSlider } from "../../../components/ReactAria/RangeSlider.js";

export const PeriodFilter = (props) => {
  const { genreList, className, focusSection } = props;
  let [period, setPeriod] = useState([2010, 2020]);
  let [filterStatement, setFilterStatement] = useState("");

  useEffect(() => {
    setPeriod([2010, 2020]);
  }, [genreList]);

  //Update Filter List
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      modifyFilterList({
        field: "period",
        payload: period,
      })
    );
    setFilterStatement(
      period[0] < period[1]
        ? `from ${period[0] + "s"} to ${
            period[1] > 2020 ? "after 2020s" : period[1] + "s"
          }`
        : period[1] > 2020
        ? `after ${period[1] + "s"}`
        : `before ${period[0] + "s"}`
    );
  }, [period]);
  //Update Statement List
  useEffect(() => {
    dispatch(
      modifyFilterStatementList({
        field: "period",
        payload: filterStatement,
      })
    );
  }, [filterStatement]);

  return (
    <div
      className={`${className} ${
        focusSection == className ? "filter_active" : ""
      }`}
    >
      <div className="period_filter_content">
        <div className="period_range_container">
          <RangeSlider
            label="Period"
            minValue={1950}
            maxValue={2030}
            step={10}
            value={period}
            onChange={setPeriod}
            extraThumbContent={["s", "After 2020s"]}
          />
        </div>
      </div>
      <div className="period_filter_checked_display">
        <p>
          Your movie was released{" "}
          {filterStatement}
        </p>
      </div>
    </div>
  );
};
